// globalAudioManager.ts
class AudioManager {
//   currentAudio: HTMLAudioElement | null = null;
currentId: string | null = null;
audios: HTMLAudioElement[] = [];
currentAudio: HTMLAudioElement | null = null;

  play(audio: HTMLAudioElement, id: string) {
    // Stop previous main audio
    if (this.currentAudio && this.currentAudio !== audio) {
        this.currentAudio.pause();
        this.currentAudio.currentTime = 0;
    }

    this.currentAudio = audio;
    this.currentId = id;

    //  TRACK ALL AUDIOS
    this.audios.push(audio);

    // APPLY GLOBAL MUTE
    const isMuted = (window as any).isMutedGlobal === true;
    audio.muted = isMuted;

    audio.play().catch((err) => {
        console.warn(`AudioManager: play() blocked:`, err);
    });

    //  CLEANUP AFTER FINISH
    audio.onended = () => {
        this.audios = this.audios.filter(a => a !== audio);
    };
  }

  stop() {
    this.audios.forEach(audio => {
        audio.pause();
        audio.currentTime = 0;
    });

    this.audios = [];
    this.currentAudio = null;
    this.currentId = null;
  }

  //  Use this only on navigation / component unmount
  clear() {
    if (this.currentAudio) {
      this.currentAudio.pause();
      this.currentAudio.currentTime = 0;
      this.currentAudio = null;
      this.currentId = null;
    }
  }

  isActive(id: string) {
    return this.currentId === id;
  }

  //  Apply mute to whatever audio is currently tracked
  applyMute(muted: boolean) {
    if (this.currentAudio) {
      this.currentAudio.muted = muted;
    }
  }
}

export const audioManager = new AudioManager();
